<nz-form-item class="ui-form-textarea">
  <nz-form-label *ngIf="!hideLabel" [nzRequired]="isRequired">{{
    label | localization
  }}</nz-form-label>
  <nz-form-control
    [nzValidateStatus]="control ?? 'success'"
    [nzErrorTip]="errorTip | localization"
  >
    <textarea
      nz-input
      [placeholder]="placeholder | localization"
      [nzAutosize]="{ minRows, maxRows }"
      [ngModel]="value"
      (blur)="onBlur()"
      (input)="onInput($event)"
      [disabled]="disabled"
      [mask]="maskConfig?.mask"
      [prefix]="maskConfig?.prefix ?? ''"
      [patterns]="maskConfig?.patterns"
      [dropSpecialCharacters]="!!maskConfig?.dropSpecialCharacters"
      [specialCharacters]="maskConfig?.specialCharacters ?? []"
      [thousandSeparator]="maskConfig?.thousandSeparator ?? ''"
    ></textarea>
  </nz-form-control>
</nz-form-item>
